export default __webpack_public_path__ + "static/media/back-icon.5da67066.svg";